var VersionInterceptor_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { libVersion } from '../../../assets/lib-version';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "../services/monitoring.service";
let VersionInterceptor = class VersionInterceptor {
  static {
    VersionInterceptor_1 = this;
  }
  monitoringService;
  // Has to be any because libVersion is generated using JS
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  version = libVersion.version;
  constructor(monitoringService) {
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', VersionInterceptor_1), 'constructor');
  }
  intercept(req, next) {
    const modifiedReq = req.clone({
      setHeaders: {
        'digital-ui-lib-version': this.version ?? ''
      }
    });
    return next.handle(modifiedReq);
  }
  static ɵfac = function VersionInterceptor_Factory(t) {
    return new (t || VersionInterceptor)(i0.ɵɵinject(i1.MonitoringService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VersionInterceptor,
    factory: VersionInterceptor.ɵfac
  });
};
VersionInterceptor = VersionInterceptor_1 = __decorate([ConstructorName('VersionInterceptor')], VersionInterceptor);
export { VersionInterceptor };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VersionInterceptor, [{
    type: Injectable
  }], () => [{
    type: i1.MonitoringService
  }], null);
})();
